import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/redirect', component: () => import('@/views/redirect/index'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'el-icon-s-home' }
    },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商品', icon: 'el-icon-s-shop' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '商品列表', icon: '' }
    },
    {
      path: 'productCate',
      name: 'productCate',
      component: () => import('@/views/pms/productCate/index'),
      meta: { title: '商品分类', icon: '' }
    },
    {
      path: 'carousel',
      name: 'carousel',
      component: () => import('@/views/pms/carousel/index'),
      meta: { title: '轮播列表', icon: '' }
    },
    {
      path: 'activity',
      name: 'activity',
      component: () => import('@/views/pms/activity/index'),
      meta: { title: '活动列表', icon: '' }
    },
    {
      path: 'shippingTemplates',
      name: 'shippingTemplates',
      component: () => import('@/views/pms/shippingTemplates/index'),
      meta: { title: '运费模板', icon: '' }
    },
    // {
    //   path: 'product/edit',
    //   name: 'productEdit',
    //   component: () => import('@/views/pms/product/edit'),
    //   meta: { title: '商品编辑', icon: '' },
    //   hidden: true
    // },
    // {
    //   path: 'product/detail',
    //   name: 'productDetail',
    //   component: () => import('@/views/pms/product/detail'),
    //   meta: { title: '商品详情', icon: '' },
    //   hidden: true
    // },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: '订单列表', icon: '' }
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: { title: '售后管理', icon: '' }
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: () => import('@/views/oms/logistics/index'),
        meta: { title: '物流快递', icon: '' }
      },
      {
        path: 'afterAddress',
        name: 'afterAddress',
        component: () => import('@/views/oms/afterAddress/index'),
        meta: { title: '售后地址', icon: '' }
      },
      {
        path: 'orderCustoms',
        name: 'orderCustoms',
        component: () => import('@/views/oms/orderCustoms/index'),
        meta: { title: '报关管理', icon: '' }
      },
      {
        path: 'omsManualOrder',
        name: 'omsManualOrder',
        component: () => import('@/views/oms/omsManualOrder/index'),
        meta: { title: '宁兴错误订单', icon: '' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userList',
    name: 'user',
    meta: { title: '会员管理', icon: 'el-icon-s-custom' },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/user/userList/index'),
        meta: { title: '会员列表', icon: '' }
      },
      {
        path: 'logout',
        name: 'logout',
        component: () => import('@/views/user/logout/index'),
        meta: { title: '注销管理', icon: '' }
      },
      {
        path: 'memberLevel',
        name: 'memberLevel',
        component: () => import('@/views/user/memberLevel/index'),
        meta: { title: '会员等级', icon: '' }
      },
      {
        path: 'levelTask',
        name: 'levelTask',
        component: () => import('@/views/user/levelTask/index'),
        meta: { title: '等级任务', icon: '' }
      },
      {
        path: 'onlineMember',
        name: 'onlineMember',
        component: () => import('@/views/user/onlineMember/index'),
        meta: { title: '在线会员', icon: '' }
      },
      {
        path: 'memberPromotion',
        name: 'memberPromotion',
        component: () => import('@/views/user/memberPromotion/index'),
        meta: { title: '会员推广图', icon: '' }
      },
      {
        path: 'studioList',
        name: 'studioList',
        component: () => import('@/views/user/studioList/index'),
        meta: { title: '工作室名单', icon: '' }
      },
      {
        path: 'userLog',
        name: 'userLog',
        component: () => import('@/views/user/userLog/index'),
        meta: { title: '会员日志', icon: '' }
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/member',
    name: 'finance',
    meta: { title: '财务管理', icon: 'el-icon-s-finance' },
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/finance/member/index'),
        meta: { title: '会员账单', icon: '' }
      },
      {
        path: 'withdraw',
        name: 'withdraw',
        component: () => import('@/views/finance/withdraw/index'),
        meta: { title: '提现管理', icon: '' }
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/finance/recharge/index'),
        meta: { title: '充值管理', icon: '' }
      },
      {
        path: 'rechargeConfig',
        name: 'rechargeConfig',
        component: () => import('@/views/finance/rechargeConfig/index'),
        meta: { title: '充值金额配置', icon: '' }
      },
      {
        path: 'transfer',
        name: 'transfer',
        component: () => import('@/views/finance/transfer/index'),
        meta: { title: '转账管理', icon: '' }
      },
      {
        path: 'paymentRecord',
        name: 'paymentRecord',
        component: () => import('@/views/finance/paymentRecord/index'),
        meta: { title: '第三方支付记录', icon: '' }
      }
    ]
  },
  {
    path: '/settlement',
    component: Layout,
    redirect: '/settlement/period',
    name: 'settlement',
    meta: { title: '结算管理', icon: 'el-icon-s-management' },
    children: [
      {
        path: 'period',
        name: 'period',
        component: () => import('@/views/settlement/period/index'),
        meta: { title: '结算周期', icon: '' }
      },
      {
        path: 'monthly-statistics',
        name: 'monthly-statistics',
        component: () => import('@/views/settlement/monthly-statistics/index'),
        meta: { title: '月结统计', icon: '' }
      },
      {
        path: 'monthly-reward',
        name: 'monthly-reward',
        component: () => import('@/views/settlement/monthly-reward/index'),
        meta: { title: '月结奖励', icon: '' }
      },
      {
        path: 'reward-source',
        name: 'reward-source',
        component: () => import('@/views/settlement/reward-source/index'),
        meta: { title: '月结奖励来源', icon: '' }
      },
      {
        path: 'studio-performance',
        name: 'studio-performance',
        component: () => import('@/views/settlement/studio-performance/index'),
        meta: { title: '工作室业绩', icon: '' }
      },
      {
        path: 'budget-rewards',
        name: 'budget-rewards',
        component: () => import('@/views/settlement/budget-rewards/index'),
        meta: { title: '预算奖励', icon: '' }
      },
      {
        path: 'budget-rewards-detail',
        name: 'budget-rewards-detail',
        component: () => import('@/views/settlement/budget-rewards-detail/index'),
        meta: { title: '预算奖励明细', icon: '' }
      },
      {
        path: 'recalculate',
        name: 'recalculate',
        component: () => import('@/views/settlement/recalculate/index'),
        meta: { title: '重算业绩', icon: '' }
      },
      {
        path: 'recalculate-detail',
        name: 'recalculate-detail',
        component: () => import('@/views/settlement/recalculate-detail/index'),
        meta: { title: '重算业绩记录', icon: '' }
      }
    ]
  },
  {
    path: '/orderCalculate',
    component: Layout,
    redirect: '/orderCalculate/calculate',
    name: 'orderCalculate',
    meta: { title: '订单测算', icon: 'el-icon-s-operation' },
    children: [
      {
        path: 'calculate',
        name: 'calculate',
        component: () => import('@/views/orderCalculate/calculate/index'),
        meta: { title: '测算订单', icon: '' }
      },
      {
        path: 'shopping',
        name: 'shopping',
        component: () => import('@/views/orderCalculate/shopping/index'),
        meta: { title: '测算购物清单', icon: '' }
      },
      {
        path: 'bill',
        name: 'bill',
        component: () => import('@/views/orderCalculate/bill/index'),
        meta: { title: '测算账单', icon: '' }
      },
      {
        path: 'performance',
        name: 'performance',
        component: () => import('@/views/orderCalculate/performance/index'),
        meta: { title: '测算业绩清单', icon: '' }
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: '' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: '' }
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: '' }
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/ums/log/index'),
        meta: { title: '日志列表', icon: '' }
      },
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js